<script>
  import curd from './Base/Crud'
  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增期刊', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '期刊名称',
              prop: 'title',
              rules: [{
                required: true, message: '名称不能为空', trigger: 'blur'
              }],
              span: 24
            },
            {
              label: '期刊内容',
              overHidden: true,
              prop: 'content',
              span: 24,
              rules: [{
                required: true, message: '内容不能为空', trigger: 'blur'
              }],
              type: 'textarea',
              align: 'left'
            },
            {
              label: '图片',
              prop: 'filepaths',
              dataType: 'string', // 单图不要此属性
              type: 'upload',
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24,
              rules: [{
                required: true, message: '图片不能为空', trigger: 'blur'
              }]
            },
            {
              label: '排序id',
              prop: 'sort_id',
              type: 'number',
              value: 100,
              tip: '排序ID越小越靠前'
            },
            {
              label: '发布时间',
              prop: 'created_at',
              display: false
            }
          ]
        }
      }
    }
  }
</script>
